import { FREELANCECANDIDATEAPPLYSTATUS } from "../../ENVIRONMENT";

// api for freelance job apply
async function freeapplyJob(token,id,data) {
  const response = await fetch(FREELANCECANDIDATEAPPLYSTATUS+`/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body:JSON.stringify(data),
});
  return response;
}

export {freeapplyJob}